import { JSX } from "solid-js";

import Trans from "@repo/localization/jsx.macro";
import Expand from "@repo/ui/animation/Expand";
import Fade from "@repo/ui/animation/Fade";
import ExpressiveIcon from "@repo/ui/branding/ExpressiveIcon";
import Card from "@repo/ui/containers/Card";

declare namespace SignupOffer {
  type Props = {
    class?: string;
    children: JSX.Element;
  };
}

function SignupOffer({ class: className, children }: D<SignupOffer.Props>) {
  return (
    <Expand direction="y">
      <Fade transition="var(--normal-s) calc(var(--normal-s) / 2)">
        <div class={className}>
          <Card outline class="p-2">
            <div class="row-center gap-2">
              <div class="expand">
                <div class="text:small+ color:primary mb-1">
                  <Trans>Special offer</Trans>
                </div>
                {children}
              </div>
              <ExpressiveIcon name="creditCashback" size="small" />
            </div>
          </Card>
        </div>
      </Fade>
    </Expand>
  );
}

export default SignupOffer;
